var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDialogSignContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8333 96.7969L99.4236 95.9492L99.6667 95.707V100.187V106H93.8333H58.8333H53V100.187V49.8125V44H58.8333H84.1111L99.6667 59.5V67.8555L93.8333 73.668V63.375H80.2222V49.8125H58.8333V100.187H93.8333V96.7969ZM71.4722 80.8125H73.4167H74.7535L75.2396 82.2656L77.0625 88.4414L77.4271 87.7148L78.0347 86.625H79.25H83.1389H84.2326L84.8403 87.7148L86.1771 90.5H87.0278H87.1493H88.4861L89.3368 84.3242L106.594 67.25L115.222 75.8477L97.9653 92.9219L88 94.375H87.1493H87.0278H85.0833H83.8681L83.2604 93.4062L81.9236 90.5H80.3438L79.0069 93.4062L78.3993 94.375H77.3056H76.3333H74.875L74.3889 93.043L72.4444 86.2617L70.3785 93.043L69.8924 94.375H68.5556H64.6667H62.7222V90.5H64.6667H67.0972L69.5278 82.2656L70.0139 80.8125H71.4722ZM123 68.0977L117.896 73.1836L109.267 64.5859L114.372 59.5L123 68.0977Z",
    fill: "url(#paint0_linear_4723_203463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4723_203463",
    x1: 87.505,
    y1: 44,
    x2: 87.505,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogSignContract);
export default __webpack_public_path__ + "static/media/img_dialog_sign_contract.2ba2708d5ec4692e149308e094e383d8.svg";
export { ForwardRef as ReactComponent };